import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Prism from "prismjs";
import { useEffect } from "react";
import "../vendor/css/prism-default.css";
import "../scss/posts.scss";

export default function UnresponsiveCol() {
  // Initialize Prism
  useEffect(() => {
    Prism.highlightAll();
  }, []);

  const nameExt = " | charlie-gp";
  const [postTitle, postDate, readTime] = [
    "Unresponsive Single Column in Bootstrap",
    "Nov. 6, 2022",
    "2min. read",
  ];

  return (
    <div id="posts">
      <Helmet>
        <title>{postTitle + nameExt}</title>
      </Helmet>
      <div id="post-date">
        <small>
          {postDate} &nbsp;&bull;&nbsp; {readTime} &nbsp;&bull;&nbsp;{" "}
          <Link to="/blog/">Blog</Link>
        </small>
      </div>

      <p id="post-title">{postTitle}</p>

      <br />
      <p className="post-sect">The Flex</p>
      <p>
        I am developing my portfolio using ReactJS and Bootstrap 5. Along the
        way, I have encountered a problem when setting the width of a single
        column inside the row, for example:
      </p>
      <pre>
        <code className="language-html">
          {`
<div className="row">
  <div className="col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
    ...
  </div>
</div>
          `}
        </code>
      </pre>
      <br />
      <div className="alert alert-primary align-items-center p-2">
        <small>
          <i className="bi-exclamation-circle"></i>&nbsp;Note: &nbsp;.row class
          contains :flex attribute.
        </small>
      </div>
      <br />
      <p>
        So, if there is only one <code>.col</code> inside the <code>.row</code>,
        it will just occupy the entire space of the parent and even if you set
        an <code>.offset-*</code> next to <code>.col</code>, the alignment still
        not centered.
      </p>
      <br />
      <p className="post-sect">Standalone Column</p>
      <p>
        I tried many ways just to obtain the desired output. Manipulating the
        classes using Javascript, attempted to use{" "}
        <a href="/">React Bootstrap</a>, but it's an overkill. Until, I removed
        the <code>.row</code> parent, so that the <code>width: </code> can be
        set and become standalone. Atleast, according to{" "}
        <a href="https://getbootstrap.com/docs/5.0/layout/columns/#standalone-column-classes">
          documentation
        </a>
        :
      </p>
      <pre>
        <code className="language-html">
          {`
<div className="container">
  <!--.row has been removed--> 
  <div className="col-sm-12 col-md-8 offset-md-2 col-lg-8 offset-lg-2">
    ...
  </div>
</div>
        `}
        </code>
      </pre>
      <p className="mb-0">
        That's it! <code>.col-*-*</code> is now completely responsive.
      </p>
      <p className="text-end">
        <a href="#root">
          <i className="bi-arrow-up"></i> Back to top
        </a>
      </p>
    </div>
  );
}
